import { useState, useEffect } from "react"
import { Menu, Button } from "@mantine/core"
import { ChevronDown } from "lucide-react"
import "./custom-dropdown.css"

export function CustomDropdown(props: {
	actions: { label: string; key: string | number }[]
	bestOption: string
	formId?: string
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
	value: string
	setChangeTrigger?: (value: boolean) => void
	children?: React.ReactNode
}) {
	const { actions, bestOption, formId, value, setChangeTrigger, children } = props || {}
	const [selected, setSelected] = useState<null | string>()
	const [opened, setOpened] = useState(false)

	useEffect(() => {
		if (typeof value === "number") {
			setSelected(value)
		}
		const selectedAction = actions.find((action) => action.key === value)
		if (selectedAction) {
			setSelected(selectedAction.label)
		}
	}, [value])

	const handleToggle = () => {
		setOpened(!opened)
	}

	const handleClose = () => {
		setOpened(false)
	}

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === " " || e.key === "Enter") {
			e.preventDefault()
			handleToggle()
		}
	}

	return (
		<div className="custom-dropdown">
			<Menu opened={opened} onClose={handleClose} position="bottom-start" withinPortal={false}>
				<Menu.Target>
					<Button
						id={formId}
						className="custom-dropdown-toggle"
						onClick={handleToggle}
						onKeyDown={handleKeyDown}
						variant="default"
						rightSection={<ChevronDown size={16} />}>
						<span className="header-toggle">{selected ? selected : bestOption}</span>
					</Button>
				</Menu.Target>
				<Menu.Dropdown className="custom-dropdown-menu">
					{children}
					{actions.map((action, idx) => (
						<Menu.Item
							key={idx}
							onClick={() => {
								setSelected(action.label)
								props.onChange({
									target: {
										id: formId,
										value: action.key,
									},
								} as React.ChangeEvent<HTMLInputElement>)
								setChangeTrigger?.(true)
								handleClose()
							}}>
							{action.label}
						</Menu.Item>
					))}
				</Menu.Dropdown>
			</Menu>
		</div>
	)
}
